export default __webpack_public_path__ + "static/media/mail.58ba2a38.svg";